import React, { FC, Fragment, useEffect } from "react";
import { observer } from "mobx-react";
import Toast from "ui/Toast/Toast";
import Modal from "ui/Modal/Modal";
import { useStore } from "store";
import { setBodyOverflow } from "helpers/dom";
import styles from "./Notifications.module.scss";

const Notifications: FC = () => {
  const { notifications } = useStore();
  const hidden = notifications.modals.length > 0;

  useEffect(() => {
    setBodyOverflow(hidden ? "hidden" : "auto");
  }, [hidden]);

  return (
    <Fragment>
      <div className={styles.toasts}>
        {notifications.toasts.map(toast => {
          const ToastComponent = toast.component || Toast;

          /* Close after 5 seconds, todo: add animation */
          if (!toast.permanent) {
            setTimeout(function () {
              notifications.close(toast);
            }, 5000);
          }

          return (
            <ToastComponent
              onClose={() => notifications.close(toast)}
              key={toast.id}
              {...toast.props}
            />
          );
        })}
      </div>
      <div className={styles.modals}>
        {notifications.modals.map(modal => {
          const ModalComponent = modal.component || Modal;
          return (
            <ModalComponent
              onClose={() => notifications.close(modal)}
              key={modal.id}
              {...modal.props}
            />
          );
        })}
      </div>
      <div className={styles.tooltips}>
        {notifications.tooltips.map(tooltip => {
          const ModalComponent = tooltip.component || Modal;
          return (
            <ModalComponent
              onClose={() => notifications.close(tooltip)}
              key={tooltip.id}
              {...tooltip.props}
            />
          );
        })}
      </div>
    </Fragment>
  );
};

export default observer(Notifications);
